import React from 'react';
import type { MenuItemCustomActionViewModel } from 'autogen/swagger/all';
import ChatTab from 'components/chat/models';
import { closeAllDrawers } from 'components/generic/Drawer/hooks/useDrawer';
import mediator from 'modules/mediator';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import type { DefaultMenuItemProps } from '../types';
import DefaultMenuItem from './DefaultMenuItem';

type CustomerChatMenuItemProps = {
    model: MenuItemCustomActionViewModel;
    defaultProps: DefaultMenuItemProps;
};

export default function CustomerChatMenuItem({
    model: { text },
    defaultProps: { iconUrl, styling, id },
    ...restProps
}: CustomerChatMenuItemProps) {
    return (
        <DefaultMenuItem.Button
            buttonProps={{
                onClick: () => {
                    mediator.publish('openChat', ChatTab.CustomerService);

                    GA4Tracking({
                        eventName: 'link_click',
                        context: 'menu',
                        category: 'navigation',
                        eventParams: [
                            { param_name: 'link_type', param_value: 'internal' },
                            { param_name: 'list_name', param_value: text },
                            { param_name: 'id', param_value: id }
                        ]
                    });

                    closeAllDrawers();
                }
            }}
            iconUrl={iconUrl}
            styling={styling}
            {...restProps}
        >
            {text}
        </DefaultMenuItem.Button>
    );
}
